module.exports = __webpack_public_path__ + "static/media/parar.ef0abe78.jpg";